export const AutoAdjustBackwardsLimit = {
  Off: "AutoAdjustBackwardsLimit_Off",
  Today: "AutoAdjustBackwardsLimit_Today",
  Tomorrow: "AutoAdjustBackwardsLimit_Tomorrow",
  NextWeek: "AutoAdjustBackwardsLimit_NextWeek",
  NextMonth: "AutoAdjustBackwardsLimit_NextMonth"
};

// Note: must be in same order to match indexes above
export const AutoAdjustBackwardsLimitLabel = {
  AutoAdjustBackwardsLimit_Off: "No limits",
  AutoAdjustBackwardsLimit_Today: "Do not move start dates backwards before today",
  AutoAdjustBackwardsLimit_Tomorrow: "Do not move start dates backwards before tomorrow",
  AutoAdjustBackwardsLimit_NextWeek: "Do not move start dates backwards before next week",
  AutoAdjustBackwardsLimit_NextMonth: "Do not move start dates backwards before next month"
};

export const AutoAdjustBackwardsLimitDescription = {
  AutoAdjustBackwardsLimit_Off: "Items may be adjusted to any date to resolve dependencies and constraints.",
  AutoAdjustBackwardsLimit_Today:
    "Items that start on or after today will never have their start dates adjusted backwards to before today.",
  AutoAdjustBackwardsLimit_Tomorrow:
    "Items that start on or after tomorrow will never have their start dates adjusted backwards to before tomorrow.",
  AutoAdjustBackwardsLimit_NextWeek:
    "Items that start on or after next week will never have their start dates adjusted backwards to before next week.",
  AutoAdjustBackwardsLimit_NextMonth:
    "Items that start on or after next month will never have their start dates adjusted backwards to before next month."
};

const createBackwardsLimitOption = id => {
  return {
    identifier: id,
    name: AutoAdjustBackwardsLimitLabel[id],
    description: AutoAdjustBackwardsLimitDescription[id]
  };
};

export const AutoAdjustBackwardsLimitOptions = [
  createBackwardsLimitOption(AutoAdjustBackwardsLimit.Off),
  createBackwardsLimitOption(AutoAdjustBackwardsLimit.Today),
  createBackwardsLimitOption(AutoAdjustBackwardsLimit.Tomorrow),
  createBackwardsLimitOption(AutoAdjustBackwardsLimit.NextWeek),
  createBackwardsLimitOption(AutoAdjustBackwardsLimit.NextMonth)
];
